import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogisticsTruckCountService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LogisticsTruckCountCreateDto,
  LogisticsTruckCountDto,
  LogisticsTruckCountExcelDownloadDto,
  LogisticsTruckCountUpdateDto,
} from '../proxy/controlling/dtos/logistics-truck-count';
import { LOGISTICSTRUCKCOUNT_CONFIG, LOGISTICSTRUCKCOUNT_FIELDS } from './logistics-truck-count.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-logistics-truck-count',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LogisticsTruckCountService, ConfirmationService],
  templateUrl: './logistics-truck-count.html',
  styleUrl: './logistics-truck-count.scss',
})
export class LogisticsTruckCount extends BaseHierarchicalCrudComponent<
  LogisticsTruckCountDto,
  LogisticsTruckCountCreateDto,
  LogisticsTruckCountUpdateDto,
  LogisticsTruckCountExcelDownloadDto
> {
  service = inject(LogisticsTruckCountService);
  config = LOGISTICSTRUCKCOUNT_CONFIG;
  fields = LOGISTICSTRUCKCOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: LogisticsTruckCountDto): LogisticsTruckCountUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LogisticsTruckCount';
  }
}
